/* Single – UI enhancement voor variaties (radio/checkbox/image/color) */
export function mount() {
  const $ = window.jQuery;

  document
    .querySelectorAll('form.variations_form select[name^="attribute_"]')
    .forEach((select) => {
      const uiType = (select.getAttribute('data-wk-ui') || 'select').toLowerCase();
      if (uiType === 'select') return; // laat standaard dropdown staan

      // Container
      const group = document.createElement('div');
      group.className = `wk-ui wk-ui--${uiType}`;
      group.setAttribute('role', uiType === 'checkbox' ? 'group' : 'radiogroup');

      const groupLabel =
        select.closest('.value, .label')?.previousElementSibling?.textContent || select.name;
      group.setAttribute('aria-label', groupLabel);

      // Lijst
      const list = document.createElement('div');
      list.className = 'wk-ui__list';

      const triggerWooChange = (sel) => {
        if (!sel) return;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        if ($) $(sel).trigger('woocommerce_variation_select_change');
      };

      const makeBtn = (opt) => {
        const val = opt.value;
        const lab = opt.textContent.trim();
        if (!val) return null;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wk-ui__item';
        btn.dataset.value = val;

        // staten
        if (opt.disabled) {
          btn.classList.add('is-disabled');
          btn.setAttribute('aria-disabled', 'true');
        }
        if (opt.selected) btn.classList.add('is-selected');

        // visuals
        const color = opt.dataset.swatchColor;
        const image = opt.dataset.swatchImage;

        if (uiType === 'color' && color) {
          btn.innerHTML = `<span class="wk-swatch wk-swatch--color" style="--sw:${color}"></span>`;
          btn.setAttribute('aria-label', lab);
          btn.title = lab;
        } else if (uiType === 'image' && image) {
          btn.innerHTML = `<span class="wk-swatch wk-swatch--image" style="--img:url('${image}')"></span><span class="wk-ui__label">${lab}</span>`;
        } else {
          btn.innerHTML = `<span class="wk-ui__label">${lab}</span>`;
        }

        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-disabled')) return;

          if (uiType === 'checkbox' && select.value === val) {
            // togglen toegestaan
            select.value = '';
            list.querySelectorAll('.wk-ui__item.is-selected').forEach((el) => el.classList.remove('is-selected'));
          } else {
            // gedraag als radio
            select.value = val;
            list.querySelectorAll('.wk-ui__item.is-selected').forEach((el) => el.classList.remove('is-selected'));
            btn.classList.add('is-selected');
          }
          triggerWooChange(select);
        });

        return btn;
      };

      Array.from(select.options).forEach((opt) => {
        const btn = makeBtn(opt);
        if (btn) list.appendChild(btn);
      });

      group.appendChild(list);

      // Select verbergen maar laten bestaan
      select.style.position = 'absolute';
      select.style.left = '-9999px';
      select.style.width = '1px';
      select.style.height = '1px';
      select.style.overflow = 'hidden';

      // Plaats UI direct na select
      select.parentNode.insertBefore(group, select.nextSibling);

      // Sync selectie als select verandert (history/autofill)
      select.addEventListener('change', () => {
        const v = select.value;
        list.querySelectorAll('.wk-ui__item').forEach((btn) => {
          btn.classList.toggle('is-selected', btn.dataset.value === v && v !== '');
        });
      });

      // Sync disabled/enabled state wanneer Woo verandert
      const syncDisabled = () => {
        const opts = Array.from(select.options);
        list.querySelectorAll('.wk-ui__item').forEach((btn) => {
          const v = btn.dataset.value;
          const o = opts.find((x) => x.value === v);
          const dis = o ? !!o.disabled : false;
          btn.classList.toggle('is-disabled', dis);
          btn.setAttribute('aria-disabled', dis ? 'true' : 'false');
        });
      };

      syncDisabled();

      if ($) {
        $(document).on('woocommerce_update_variation_values', 'form.variations_form', function () {
          syncDisabled();
        });

        $(document).on('reset_data', 'form.variations_form', function () {
          list.querySelectorAll('.wk-ui__item.is-selected').forEach((el) => el.classList.remove('is-selected'));
        });
      }
    });
}
